export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo21-bbceab6b652a0c5d851f8316b1f84c00.jpg";